import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

export function createActionsHook<T>(actions: T) {
    return function useActionsFunc(): T {
        const dispatch = useDispatch();
        return useMemo(() => {
            if (Array.isArray(actions)) {
                // @ts-ignore
                return actions.map((a) => bindActionCreators(a, dispatch));
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return bindActionCreators(actions as any, dispatch);
        }, [dispatch]) as T;
    };
}

export function useActions<T>(actions: T): T {
    return createActionsHook(actions)();
}
